import ControlPanelContainer from 'dashboard/apps/DashboardLayoutEditor/ControlPanel/ControlPanelContainer';
import { REPORT_TEMPLATE_TYPE_OPTIONS } from 'dashboard/apps/DashboardLayoutEditor/ControlPanel/Panels/ResourceReportPanel';
import CaseDataManagerSchemaSelect from 'dashboard/components/CaseDataManagerSchemaSelect';
import ReactSelect from 'dashboard/components/ReactSelect';
import { ModuleResourceReportV2 } from 'dashboard/modules/ResourceReportV2';
import Spacer from 'design-system/components/Spacer';
import { Heading, Label } from 'design-system/components/Text';
import { ApiModel } from 'lib/interfaces/api';
import { JsonSchemaObject } from 'lib/json-schema';

export interface ResourceReportV2PanelProps {
  module: ModuleResourceReportV2;
  dataSchema: JsonSchemaObject;
  updateModule: (module: ModuleResourceReportV2) => void;
}

const ResourceReportV2Panel = ({
  module,
  dataSchema,
  updateModule,
}: ResourceReportV2PanelProps) => {
  const handleSetReportResourceVariable = (variableToken: string) => {
    updateModule({
      ...module,
      'variable-token': variableToken,
    });
  };

  const handleSetReportTemplateType = (
    reportTemplateType: ModuleResourceReportV2['report-template-type'],
  ) => {
    updateModule({
      ...module,
      'report-template-type': reportTemplateType,
    });
  };

  return (
    <>
      <ControlPanelContainer>
        <Heading size='sm'>Settings</Heading>
        <Spacer height={2} />

        <Label id='report-resource-variable-selector-label' size='md' weight='bold'>
          Resource
        </Label>
        <CaseDataManagerSchemaSelect
          jsonSchema={dataSchema}
          inputValue={module['variable-token']}
          onValueChange={handleSetReportResourceVariable}
        />

        <Spacer height={2} />

        <Label size='md' weight='bold' id='resource-report-panel__report-template-selector--label'>
          Type
        </Label>
        <ReactSelect<ApiModel>
          id='resource-report-panel__report-template-selector'
          aria-labelledby='resource-report-panel__report-template-selector--label'
          value={module['report-template-type'] || ApiModel.ReportTemplateWatchlist}
          options={REPORT_TEMPLATE_TYPE_OPTIONS}
          onChange={handleSetReportTemplateType}
          portal={true}
        />
      </ControlPanelContainer>
    </>
  );
};

export default ResourceReportV2Panel;
